import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { NewDwellingSalesStateService } from "src/services/new-dwellings/new-dwelling-sales-state.service";
import { NewDwellingsFilterEstateTypesComponent } from "./new-dwellings-filter-estate-types/new-dwellings-filter-estate-types.component";
import { NewDwellingsFilterSaleBuildStatusComponent } from "./new-dwellings-filter-sale-build-status/new-dwellings-filter-sale-build-status.component";
import { NewDwellingsFilterOwnershipComponent } from "./new-dwellings-filter-ownership/new-dwellings-filter-ownership.component";
import { NewDwellingsFilterTimePeriodComponent } from "./new-dwellings-filter-time-period/new-dwellings-filter-time-period.component";
import { RightSidebarOptions, RightSidebarService } from "src/services/right-sidebar.service";

@Component({
    selector: "new-dwellings-filter",
    imports: [
        NewDwellingsFilterOwnershipComponent,
        NewDwellingsFilterEstateTypesComponent,
        NewDwellingsFilterSaleBuildStatusComponent,
        NewDwellingsFilterTimePeriodComponent,
    ],
    templateUrl: "./new-dwellings-filter.component.html",
    styleUrl: "./new-dwellings-filter.component.scss",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NewDwellingsFilterComponent {
    private readonly stateService = inject(NewDwellingSalesStateService);
    private readonly rightSidebarService = inject(RightSidebarService);

    filterForm = this.stateService.filterForm;

    onCloseFilter(): void {
        this.rightSidebarService.toggleSidebarVisibility(RightSidebarOptions.Filter);
    }
}
